document.addEventListener('DOMContentLoaded', async () => {
  const ShopifyDecryptor = (() => {
    const secretKey = '8f72a51c4e9b7a34'; // Same key as encryption
    const iv = '5d67c9a0421e3b89'; // Same IV as encryption

    const decodeTokenFromShopify = async (encryptedText) => {
      const decoder = new TextDecoder();

      try {
        // Decode base64-encoded encryptedText to get encrypted buffer
        const encryptedBuffer = Uint8Array.from(atob(encryptedText), (c) => c.charCodeAt(0));

        // Import the secret key
        const key = await crypto.subtle.importKey(
          'raw',
          new TextEncoder().encode(secretKey),
          { name: 'AES-CBC' },
          false,
          ['decrypt']
        );

        // Decrypt the buffer
        const decryptedBuffer = await crypto.subtle.decrypt(
          { name: 'AES-CBC', iv: new TextEncoder().encode(iv) },
          key,
          encryptedBuffer
        );

        // Decode the decrypted buffer to get base64-encoded JSON
        const base64Json = decoder.decode(decryptedBuffer);

        // Decode the JSON to retrieve the email and password
        const { email, password } = JSON.parse(atob(base64Json));

        return { email, password };
      } catch (error) {
        console.error('Decryption failed:', error.message);
        window.location.href = 'https://www.xdgesports.com/?error=true';
      }
    };

    return {
      decode: decodeTokenFromShopify,
    };
  })();

  // Check if the referrer is from a subdomain of xdgesports.com
  const referrer = new URL(document.referrer || ''); // Ensure document.referrer exists
  if (!referrer.host.endsWith('xdgesports.com')) {
    console.error('Unauthorized referrer.');
    window.location.href = 'https://www.xdgesports.com/?error=true';
    return;
  }

  // Retrieve the query parameter "key" from location.search
  const queryParams = new URLSearchParams(window.location.search);
  const encryptedText = queryParams.get('key'); // "key" holds the encrypted token

  if (encryptedText) {
    try {
      const { email, password } = await ShopifyDecryptor.decode(encryptedText);

      // Update the form fields
      const emailField = document.querySelector('#CustomerEmail');
      const passwordField = document.querySelector('#CustomerPassword');

      if (emailField && passwordField && email && password) {
        emailField.focus();
        emailField.value = email;
        passwordField.focus();
        passwordField.value = password;

        // Submit the form
        setTimeout(() => {
          const loginbutton = document.querySelector('#trigger-button');
          const mouseOverEvent = new MouseEvent('mouseover', {
            bubbles: true,
            cancelable: true,
            view: window,
          });

          // Dispatch the event to trigger hover
          loginbutton.dispatchEvent(mouseOverEvent);
          loginbutton.click();
        }, 1000); // Allow some time for fields to be updated
      } else {
        console.error('Form fields not found.');
        window.location.href = 'https://www.xdgesports.com/?error=true';
      }
    } catch (error) {
      console.error('System error:', error);
      window.location.href = 'https://www.xdgesports.com/?error=true';
    }
  } else {
    console.error('No encrypted token found.');
    window.location.href = 'https://www.xdgesports.com/?error=true';
  }
});
